var $d075cab832071e2c$exports = {};
$d075cab832071e2c$exports = {
    "maximum": `Massimo`,
    "minimum": `Minimo`
};


export {$d075cab832071e2c$exports as default};
//# sourceMappingURL=it-IT.mjs.map
